import { useEffect, useState } from 'react';
import * as types from "./store/types";
import { BrowserRouter } from "react-router-dom";
import './App.scss';
import { useDispatch, useSelector } from "react-redux";
import Cards from './components/Cardlist/Cards';
import {
  fetchAppContent,
} from "./store/actions/AppStateActions";
import FatalError from "./components/Error/FatalError/index";
import Cookies from "js-cookie";
import { clickHandler, isGemidsNull } from './shared/utility';
function App() {
  const dispatch = useDispatch();
  let gemId2 = "";
  let gemId1 = "";
  let channelCode = "";
  let cardName = "";
  const savedChannelCode = useSelector((state) => state.AppState.channelCode);
  const savedCardName = useSelector((state) => state.AppState.cardName);
  const savedGemId2 = useSelector((state) => state.AppState.gemId2);
  const savedGemId1 = useSelector((state) => state.AppState.gemId1);
  var config = window.global?.config;
  const contentCardList = useSelector((state) => state.AppState.cardList);
  const [isExitApp, setIsExitApp] = useState(false);
  const fetchAppData = () =>
    dispatch(fetchAppContent());

  const style = {
    opacity: "1",
    width: "100%",
    transform: "translate3d(0px, 0px, 0px)",
  };

  const style1 = {
   width: "100%"
  };

  const style2 = {
    top: "0px"
  };

  useEffect(() => {
    const queryString = window.location.search;
    const searchParams = new URLSearchParams(queryString);
    if (searchParams.get("CHN")) {
      channelCode = searchParams.get("CHN").trim();
    } else if (searchParams.get("chn")){
      channelCode = searchParams.get("chn").trim();
    } else {
      Exit();
    }
    if (searchParams.get("GEMID1")) {
      gemId1 = searchParams.get("GEMID1").trim();
      if(!gemId1 || gemId1===null || gemId1==="undefined"){
        Exit();
      }
    } else if(searchParams.get("gemid1")) {
      gemId1 = searchParams.get("gemid1").trim();
      if(!gemId1 || gemId1===null || gemId1==="undefined"){
          Exit();
        }
    }
    if (searchParams.get("GEMID2")) {
      gemId2 = searchParams.get("GEMID2").trim();
      if(!gemId2 || gemId2===null || gemId2==="undefined") {
          Exit();
        }
    } else if (searchParams.get("gemid2")) {
      gemId2 = searchParams.get("gemid2").trim();
      if(!gemId2 || gemId2===null || gemId2==="undefined") {
          Exit();
        }
    }
    if(searchParams.get("crdNm")){
      cardName = searchParams.get("crdNm").trim();
    }
    if (!Cookies.get("stp-change-card")) {
      if(!gemId1 || gemId1===null || gemId1==="undefined" || !gemId2 || gemId2===null || gemId2==="undefined") {
        Exit();
      }
    }
    dispatch({
      type: types.SAVE_LG_QUERY_PARAMS,
      payload: { gemId1: gemId1, gemId2: gemId2 , channelCode: channelCode , cardName : cardName},
    });
  },[]);
  
  useEffect(() => {
    if(savedChannelCode !== "")
      getAppData();
  },[savedChannelCode])
  const getAppData = async () => {
    const res = await fetch(process.env.PUBLIC_URL+`/Lgcardconfig.json`);
    config = await res.json();
    window.global = { config };
    if(contentCardList.length===0 && window.global?.config){
      if(window.global?.config.corecards_channel.indexOf(savedChannelCode)===-1){
        Exit();
      }
      fetchAppData();
    }
  };
  
  const Exit = () => {
    setIsExitApp(true);
  }

  useEffect(() => {
    //Aryan adding the check of card name (Uniqueidentifier) present in url by LG's are correct or not
    if(contentCardList.length !== 0 && window.global?.config && savedCardName !== ""){
      const lgCardList = window.global?.config?.OMLG;
      const lgCardIndex = contentCardList.findIndex((item) => item.uniqueIdentifier.toLowerCase() === savedCardName.toLowerCase() && lgCardList.indexOf(item.productType) !== -1);
      if(lgCardIndex === -1){
        Exit();
      }
      else{
        // redirection to sprint
        clickHandler(savedChannelCode);
        window.location.href = isGemidsNull(savedGemId1 , savedGemId2) ?  `${window.location.origin}/sprint/${contentCardList[lgCardIndex].uniqueIdentifier}` : `${window.location.origin}/sprint/${contentCardList[lgCardIndex].uniqueIdentifier}?GEMID1=${savedGemId1}&GEMID2=${savedGemId2}`

      }
    }
    
  } , [contentCardList])

  return (
    <>
    <BrowserRouter basename='corecards'>
      {!isExitApp ?  <div className="App"> <section className="top-page campaign-top" style={style2}>    
        <div className="wrapper">
            <h1 className="site-name">
                <a className="logo" title="SBI Card Home">SBI Card</a>
            </h1>
        </div>
      </section>
      <header className="home-header">
      <section id="features">
      <div className="content">
          <div className="slider hero-slider slick-initialized slick-slider">
            
            <div className="slick-list draggable">
              <div className="slick-track" style={style}>
                <div className="slick-slide slick-active" index="0" style={style1}>
                <img src={`${window.global?.config?.page_banner_url}`} data-desktop-src={`${window.location.origin}/sbi-card-en/assets/media/images/home/eapplyecardbanner/d-eapply-ecard-banner.jpg`} data-tab-src={`${window.location.origin}/sbi-card-en/assets/media/images/home/eapplyecardbanner/t-eapply-ecard-banner.jpg`} data-mobile-src={`${window.location.origin}/sbi-card-en/assets/media/images/home/eapplyecardbanner/m-eapply-ecard-banner.jpg`} alt="Apply for Credit Card Online with Instant Approval" title="Apply for an SBI Credit Card" />
            </div>
            </div>
            </div> 
          </div>
      </div>
      </section> 
      </header>
      
      <div className="card-list-page">{contentCardList.length
      !==0 && (<Cards/>)}</div>
      {contentCardList.length
      ==0 && <div className="loader">
      </div>}
      </div> 
       : <FatalError />
       
      }
      </BrowserRouter>
      </>
  );
  
}

export default App;
